import React from 'react';
import { IfscContentInterface } from '../components/IfscCode/ContentComponent';

export const popularBanks = [
  {
    title: 'Axis Bank',
    slug: '/ifsc-code/axis-bank',
  },
  {
    title: 'ICICI Bank Limited',
    slug: '/ifsc-code/icici-bank',
  },
  {
    title: 'Indian Bank',
    slug: '/ifsc-code/indian-bank',
  },
  {
    title: 'HDFC Bank',
    slug: '/ifsc-code/hdfc-bank',
  },
  {
    title: 'Canara Bank',
    slug: '/ifsc-code/canara-bank',
  },
  {
    title: 'Andhra Bank',
    slug: '/ifsc-code/andhra-bank',
  },
  {
    title: 'SBI',
    slug: '/ifsc-code/state-bank-of-india',
  },
  {
    title: 'Union Bank of India',
    slug: '/ifsc-code/union-bank-of-india',
  },
  {
    title: 'Bank of Baroda',
    slug: '/ifsc-code/bank-of-baroda',
  },
  {
    title: 'Syndicate Bank',
    slug: '/ifsc-code/syndicate-bank',
  },
  {
    title: 'Yes Bank',
    slug: '/ifsc-code/yes-bank',
  },
  {
    title: 'Bank of India',
    slug: '/ifsc-code/bank-of-india',
  },
  {
    title: 'Central Bank of India',
    slug: '/ifsc-code/central-bank-of-india',
  },
  {
    title: 'Kotak Mahindra Bank',
    slug: '/ifsc-code/kotak-mahindra-bank',
  },
  {
    title: 'Allahabad Bank',
    slug: '/ifsc-code/allahabad-bank',
  },
  {
    title: 'Corporation Bank',
    slug: '/ifsc-code/corporation-bank',
  },
  {
    title: 'Indusind Bank',
    slug: '/ifsc-code/indusind-bank',
  },
  {
    title: 'Federal Bank',
    slug: '/ifsc-code/federal-bank',
  },
  {
    title: 'Punjab National Bank',
    slug: '/ifsc-code/punjab-national-bank',
  },
  {
    title: 'United Bank of India',
    slug: '/ifsc-code/united-bank-of-india',
  },
  {
    title: 'RBL Bank',
    slug: '/ifsc-code/rbl-bank',
  },
  {
    title: 'South Indian Bank',
    slug: '/ifsc-code/south-indian-bank',
  },
  {
    title: 'IDFC Bank',
    slug: '/ifsc-code/idfc-bank',
  },
  {
    title: 'IDBI Bank',
    slug: '/ifsc-code/idbi-bank',
  },
  {
    title: 'Dena Bank',
    slug: '/ifsc-code/dena-bank',
  },
  {
    title: 'Bandhan Bank',
    slug: '/ifsc-code/bandhan-bank',
  },
  {
    title: 'UCO Bank',
    slug: '/ifsc-code/uco-bank',
  },
  {
    title: 'Vijaya Bank',
    slug: '/ifsc-code/vijaya-bank',
  },
  {
    title: 'Karnataka Bank',
    slug: '/ifsc-code/karnataka-bank',
  },
  {
    title: 'Citi Bank',
    slug: '/ifsc-code/citi-bank',
  },
];

export const IfscContents: IfscContentInterface[] = [
  {
    id: 'whatIsIFSCcode',
    header: 'What is IFSC code?',
    para1: [
      'IFSC ( Indian Financial System Code ). IFSC Code is a unique eleven-digit number which is a combination of alphabets and numbers. IFSC code is allotted by the Reserve Bank of India (RBI) to all banks and its branches. The IFSC code of a bank can be commonly found on a bank account passbook, cheque leaf issued by the bank or on the RBI website. Any kind of fund transfer through a bank requires a valid IFSC. The different types of fund transfers are NEFT, RTGS and IMPS.',
    ],
  },
  {
    id: 'howToFindIFSCcode',
    header: 'How to find IFSC code?',
    para1: ['Ways to find IFSC codes'],
    list: [
      'IFSC code can be found on cheque leaf and bank passbook of the respective bank.',
      'Banks and respective branch list of IFSC codes can be obtained from Reserve Bank of India’s website.',
      'The IFSC code of a particular bank can also be found on the banks’ official website.',
    ],
  },
  {
    id: 'benefitsIFSCcode',
    header: 'Benefits of IFSC Code',
    para1: ['Benefits of IFSC Code are :'],
    list: [
      'Helps to identify a Bank and its respective branch',
      'Eliminates errors in the process of fund transfer',
      'Transfers done with IFSC such as NEFT, RTGS and IMPS are accurate',
    ],
  },
  {
    id: 'benefitsMICRcode',
    header: 'Benefits of MICR Code',
    para1: [
      'Benefits of MICR Codes are:',
      'MICR code enables efficient, quick and error-free processing of cheques. This is possible with magnetic ink, reading machines and technology used in MICR.',
    ],
  },
  {
    id: 'details',
    header: 'Details of Fund Transfers Using IFSC',
    para1: ['Benefits of MICR Codes are:'],
    table: {
      headers: [
        {
          value: 'Transaction Charges',
          colspan: 4,
        },
      ],
      rows: [
        {
          data: [
            {
              align: 'center',
              value: ' Amount',
            },
            {
              align: 'center',
              value: 'NEFT',
            },
            {
              align: 'center',
              value: 'RTGS',
            },
            {
              align: 'center',
              value: 'IMPS',
            },
          ],
        },
        {
          data: [
            {
              value: ' Up to Rs. 10,000',
            },
            {
              value: ' Rs. 2.50',
            },
            {
              value: 'Min. 2  Lakhs',
            },
            {
              value: 'Rs. 5.00',
            },
          ],
        },
        {
          data: [
            {
              value: 'Rs 10,000 – 2 Lakh',
            },
            {
              value: ' Rs. 15.00',
            },
            {
              value: 'Rs. 26',
            },
            {
              value: 'Rs. 10.00',
            },
          ],
        },
        {
          data: [
            {
              value: 'Above 2 Lakh',
            },
            {
              value: ' Rs 25.00',
            },
            {
              value: 'Rs. 51',
            },
            {
              value: ' Rs. 15.00',
            },
          ],
        },
      ],
    },

    para2: [
      '* The above-mentioned charges are only indicative in nature. Each Bank has their own charges within these limits. Check charges from respective bank’s website.',
      'NEFT – 8 A.M – 7 P.M (Weekdays)',
      'RTGS – 9 AM – 4:30 P.M (Weekdays)',
      'IMPS – 24 hours  365 days',
    ],
  },
  {
    id: 'transfer',
    header: 'How to transfer money with IFSC code?',
    para1: [
      'IFSC Code enables you to transfer money in a quick, easy and hassle-free manner. RBI has assigned IFSC codes specific to each bank and its branches. Fund transfers are done through NEFT, RTGS and IMPS fund with a valid IFSC code. Let’s find out how IFSC Code works while transferring money. Assume the IFSC code of ICICI Bank, Mumbai branch is ICIC000027.',
      'Steps to transfer money with IFSC code:',
    ],
    list: [
      'The first four digits of IFSC code identify the bank, here it is ICICI Bank.',
      'The 5th digit is generally 0 (Zero).',
      'The following 6 characters 000027, identifies the specific branch of the bank',
    ],
    para2: [
      ' When a fund transfer is initiated by the payer be it NEFT, RTGS or IMPS. He/she has to provide the bank details such as bank name, branch, account number and the IFSC code of the payee. Once the payer provides all the required details only then will the fund be transferred to the account of the payee with the help of IFSC Code in an error-free manner. Fund transfer with IFSC code is secure, convenient and takes minutes from the time of initiation.',
    ],
  },

  {
    id: 'transferSMS',
    header: 'Transfer Funds Through SMS',
    para1: [
      'Nowadays you can transfer funds through SMS on a mobile with the help of IFSC code. Let’s see how:',
    ],
    list: [
      'To transfer money through the SMS, you need to first link your mobile number to your bank account by registering your phone number for mobile banking services.',

      'To register your mobile, you need to fill an application requesting mobile banking services, after which you will receive a unique 7 digit number which is otherwise known as MMID and mPin.',

      'Once you are registered for mobile services with your respective banks, you are required to create an SMS and type IMPS along with payee details like payee name, bank, branch, account number and IFSC code of the payee bank along with the sum amount you want to transfer.',

      'Once you confirm the transaction and send the SMS, you will receive a confirmation message where you will have to enter your mPin.',

      'Enter the mPin, and select ok. The fund will be transferred to the respective payee account.',
    ],
  },
  {
    id: 'IFSCvsMICR',
    header: 'Difference between IFSC and MICR code',
    para1: [
      'Magnetic ink character recognition code (MICR) is a technology that enables faster processing of cheques by recognizing unique characters printed on the cheque. MICR consists of a 9 digit code. The first three digits of the MICR code represent the city, the next three give the bank code and the last three digits denote the branch of the bank. Similar to an IFSC code, every branch of a bank has a specific MICR code. While IFSC is used for online fund transactions, MICR is used for cheques.',

      'Let’s understand the difference between IFSC and MICR',
    ],
    table: {
      headers: [
        {
          value: 'IFSC Code',
        },
        {
          value: 'MICR Code',
        },
      ],
      rows: [
        {
          data: [
            {
              value:
                ' Used to facilitate electronic fund transfers between banks and individuals in India.',
            },
            {
              value:
                'MICR code is to facilitate and make cheque processing more efficient.',
            },
          ],
        },
        {
          data: [
            {
              value: 'IFSC is an 11 character alphanumeric code.',
            },
            {
              value: 'MICR is a 9-digit code.',
            },
          ],
        },
        {
          data: [
            {
              value:
                'MThe first four characters indicate the name of the bank.',
            },
            {
              value:
                'The first three digits represent the city code where the bank branch is located.',
            },
          ],
        },
        {
          data: [
            {
              value: 'Last 6 digits represent the bank branch location.',
            },
            {
              value: 'Last three digits indicate the code of the bank branch.',
            },
          ],
        },
      ],
    },

    para2: [
      ' Monetary transactions are not limited to online transactions, NEFT, RTGS or IMPS alone. There are other banking instruments such as cheques which require a similar verification and authentication procedure. This is where Magnetic ink character recognition code (MICR) is necessary before processing a transaction for a cheque.',
    ],
  },
];

export const BankSpecificContents = [
  {
    id: 'howtofind',
    header: 'How to find IFSC Code?',
    list: [
      'IFSC code can be found on cheque leaf and bank passbook of the respective bank.',
      'Banks and respective branch list of IFSC codes can be obtained from Reserve Bank of India’s website.',
      'The IFSC code of a particular bank can also be found on the banks’ official website.',
    ],
  },
  {
    id: 'usesIFSC',
    header: 'Uses of IFSC Code',
    image: 'https://assets1.cleartax-cdn.com/s/img/2018/08/05130328/ifsc1.png',
  },
  {
    id: 'formatIFSC',
    header: 'Format of IFSC Code',
    para1: [
      'The 11 alphanumeric code of IFSC is structured in a pattern where the first four characters representing the name of the bank, while the last six characters represent the branch of the bank. The fifth character is generally 0 (zero) reserved for future utilisation. The format of IFSC is as below.',
    ],
    table: {
      headers: [
        {
          value: '1',
        },
        {
          value: '2',
        },
        {
          value: '3',
        },
        {
          value: '4',
        },
        {
          value: '5',
        },
        {
          value: '6',
        },
        {
          value: '7',
        },
        {
          value: '8',
        },
        {
          value: '9',
        },
        {
          value: '10',
        },
        {
          value: '11',
        },
      ],
      rows: [
        {
          data: [
            {
              colspan: 4,
              value: ' Bank Code',
            },
            {
              value: '0',
            },
            {
              colspan: 6,
              value: 'Branch Code',
            },
          ],
        },
      ],
    },
  },
  {
    id: 'howMICR',
    header: 'How to find MICR Code',
    list: [
      'MICR code can be found on a cheque leaf and bank passbook.',
      'You can also find MICR code on the specific bank’s website.',
    ],
    image:
      'https://assets1.cleartax-cdn.com/cleartax/images/1649836804_chequeimageforifscarticleb.webp',
  },
];

export const IFSCLandingFAQS: Array<{
  header: string;
  content: React.ReactElement | string;
}> = [
  {
    header: 'What is the IFSC code of a bank?',
    content: (
      <p>
        IFSC stands for Indian Financial System Code. An IFSC code is a unique
        11-digit number, which is a blend of alphabets and numerals.
      </p>
    ),
  },
  {
    header: 'Is the IFSC code same as the branch code?',
    content: <p>An IFSC code is not the same as a branch code.</p>,
  },
  {
    header: 'What is a branch code?',
    content: (
      <p>
        A branch code is a unique identifying code for a particular branch of a
        bank. Each bank branch is differentiated by its branch code.
      </p>
    ),
  },
  {
    header: 'What is a MICR code?',
    content: (
      <p>
        Magnetic Ink Character Recognition (MICR) is a 9-digit code that helps
        identify a specific bank branch. This MICR code is a part of the
        Electronic Clearing System (ECS), used to clear cheques on a routine
        basis.
      </p>
    ),
  },
];
